﻿import Swal from "sweetalert2";

export function DisplaySuccessToast(text) {
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  Toast.fire({
    icon: "success",
    title: text,
  });
}

export function DisplaySuccessDialog(title, text, icon, buttonText) {
  Swal.fire({
    title: title,
    text: text,
    icon: icon,
    button: buttonText,
  });
}

export function DisplayErrorToast(text) {
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 6000,
    timerProgressBar: true,
    onOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  Toast.fire({
    icon: "error",
    title: text,
  });
}

export function DisplayLoginErrorAlert() {
  DisplayErrorToast(
    "Uw gebruikersnaam of wachtwoord was onjuist. Probeer het opnieuw."
  );
}

export function DisplayLoginSuccessAlert() {
  DisplaySuccessToast("U werd succesvol ingelogd.");
}
